import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=31cf1149&lang=scss&rel=stylesheet%2Fscss"

const __exports__ = script;

export default __exports__